module.exports = __webpack_public_path__ + "static/img/testimony (23).baa27e24.jpg";